import axios from 'axios';
import { Config } from '../utils/config';
import { readSavedCompanyId } from '../utils/sessionStorage';

export const apiInstance = axios.create({
  baseURL: `${Config.ApiBaseUrl}`,
});

interface ApiConfig {
  token?: string;
}

export const configureApiInstance = (config: ApiConfig) => {
  if (!apiInstance) {
    return;
  }
  const { token } = config;
  if (token) {
    apiInstance.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
  }
};

export const configureAuthOnlyInstance = (config: ApiConfig) => {
  if (!apiInstance) {
    return;
  }
  const { token } = config;
  if (token) {
    apiInstance.defaults.headers.common = {
      Authorization: `Bearer ${token}`
    };
  }
};

export const configureOktaApiInstance = (config: ApiConfig, debtorId: string) => {
  if (!apiInstance) {
    return;
  }
  const { token } = config;
  const companyId = readSavedCompanyId() ?? 1; // Fallback to 1 if not set
  
  if (token) {
    apiInstance.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
      debtorid: debtorId,
      companyid: companyId,  
    };
  }
};